import React from 'react'

const CreateWorkManualDescription = () => (
    <>
        <p>
            Before registering a work, the first step is to search The MLC database to ensure the work does not already
            exist.
        </p>
        <p>
            Enter the two required search criteria below, then click <strong> Search. </strong>
        </p>
        <br />
        <p>
            If your work does not appear in the search results, click the
            <strong> Create New Work </strong> button to continue with registration.
        </p>
        <br />
        <p>
            If you do locate your work in the search results, click on the work, then on the next page, click the{' '}
            <strong>Claim shares on this work</strong> button.
        </p>
    </>
)

export default CreateWorkManualDescription
